var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWhishlist(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 28.905,
    height: 26.522,
    viewBox: "0 0 28.905 26.522",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "noun-love-4726271",
    d: "M78.837,23.09a8.819,8.819,0,0,0-6.251,15.06l11.229,11.2a.9.9,0,0,0,1.274,0L96.32,38.15a8.772,8.772,0,0,0-11.869-12.9,8.807,8.807,0,0,0-5.615-2.157Zm0,1.8a7.027,7.027,0,0,1,4.978,2.06.9.9,0,0,0,1.274,0,7.028,7.028,0,0,1,9.956,9.922L84.452,47.436,73.859,36.87a7.022,7.022,0,0,1,4.978-11.983Z",
    transform: "translate(-70 -23.09)",
    fill: "#0f0f0f",
    fillRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhishlist);
export default __webpack_public_path__ + "static/media/whishlist.b5519991e3a9d66aabaa0733ca31ae31.svg";
export { ForwardRef as ReactComponent };